import { render } from "./ConfirmTemplateManageView.vue?vue&type=template&id=0995b6c9&scoped=true"
import script from "./ConfirmTemplateManageView.vue?vue&type=script&lang=js"
export * from "./ConfirmTemplateManageView.vue?vue&type=script&lang=js"

import "./ConfirmTemplateManageView.vue?vue&type=style&index=0&id=0995b6c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0995b6c9"]])

export default __exports__